export const LAWNSTARTER = 'lawnstarter';
export const LAWNLOVE = 'lawnlove';
